// extracted by mini-css-extract-plugin
module.exports = {"section":"EvBM5","list":"_3yRrQ","listItem":"Nj7A9","listItemHome":"_6SRTg","loadingHome":"nDzHO","listItemAway":"JuxV3","loadingAway":"_3Gq9J","separator":"_3OB0-"};